import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '../Styles/app.scss';
import { Landing } from './Landing';
import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: 'https://19bd6ca4353742cb930e5766141289e7@o4504526605910016.ingest.sentry.io/4505233881038848',
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    autoSessionTracking: true,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

/**
 * LandingBootstrap.tsx needs to be kept a super simple
 * basic React function that renders natively
 * in Internet explorer. Only import React.
 * No new ES6+ features
 */
ReactDOM.render(<Landing />, document.getElementById('landing'));
